import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { UserValidators } from 'app/shared/models/validators/user-validators';
import { UserService } from 'app/shared/services/user.service';
import { of } from 'rxjs';
import { InputErrorComponent, Key, tr } from '@kpd/framework-ngx';
import { catchError } from 'rxjs/operators';

@Component({
  selector: 'app-change-password-form-group',
  templateUrl: './change-password-formgroup.component.html',
})
export class ChangePasswordFormgroupComponent implements OnInit {
  @Input()
  userKey: Key<string>;
  @Input()
  disabled = false;
  @Input()
  localUser = false;

  @Output()
  loadingChanged = new EventEmitter<boolean>();
  @Output()
  passwordChanged = new EventEmitter<void>();
  form: FormGroup = new FormGroup({});
  error?: string;

  constructor(private formBuilder: FormBuilder, private userService: UserService) {}

  ngOnInit(): void {
    this.form = this.formBuilder.group(
      {
        oldPassword: new FormControl(null, [
          !this.localUser ? Validators.required : Validators.maxLength(50),
          Validators.maxLength(50),
        ]),
        password: new FormControl(null, [Validators.required, Validators.maxLength(50)]),
        confirmPassword: new FormControl(null, [Validators.required, Validators.maxLength(50)]),
      },
      { validator: UserValidators.matchPassword },
    );
  }

  onConfirmPasswordInput(): void {
    this.form.controls.confirmPassword.markAsTouched();
  }

  public onSubmit(): boolean {
    this.error = undefined;

    this.form['submitted'] = true;
    if (!this.isValid(this.form)) {
      console.log('not valid');
      return false;
    }

    this.loadingChanged.emit(true);
    this.userService
      .changePassword(this.userKey, this.form.value.oldPassword, this.form.value.password, this.localUser)
      .pipe(
        catchError((error) => {
          if (error.status !== 400) {
            return of(false);
          }
          if (error.details.error.length === 1) {
            this.error = tr('Password change failed') + ': ' + error.details.error[0];
          } else if (error.details.error.length > 1) {
            InputErrorComponent.errorMessages['password'] = error.details.error[1];
            this.form.controls.password.setErrors({ password: true });
            this.form.controls.confirmPassword.setErrors({ password: true });
            this.form.updateValueAndValidity();
          }
          return of(false);
        }),
      )
      .subscribe((result) => {
        this.loadingChanged.emit(false);
        if (result) {
          this.passwordChanged.emit();
        }
      });
    return true;
  }

  private isValid(form: FormGroup): boolean {
    if (!form.dirty) {
      return false;
    }

    if (form.invalid) {
      return false;
    }

    return true;
  }

  hasError(fieldName: string): boolean {
    const field = this.form.get(fieldName);
    if (field) {
      const invalid = field.invalid && (field.dirty || field.touched || this.form['submitted']);
      return invalid;
    }
    return false;
  }
}
